function About() {
  return (
    <section className="section about" id="about">
      <div className="section-label"><span>01</span><p>About</p></div>
      <div className="section-body about-grid">
        <h2>I like difficult problems—and making their solutions feel simple.</h2>
        <div className="about-copy">
          <p>My background spans quantitative investing, applied mathematics, and software engineering. I enjoy moving between open-ended research questions and the practical engineering needed to explore them well.</p>
          <p>I’m especially drawn to systems where correctness matters, feedback loops are short, and good engineering creates real leverage. I care about understanding the problem deeply, then finding the simplest durable solution.</p>
          <p>Away from the keyboard, I’m a competitive speedcuber, table tennis player, and <span className="magic-word" tabIndex="0">magician</span>—three disciplines that have taught me a surprising amount about practice, precision, and performance.</p>
        </div>
      </div>
    </section>
  );
}

export default About;
